module.exports = __webpack_public_path__ + "next.svg";


//////////////////
// WEBPACK FOOTER
// ./~/ag-grid/src/styles/material-icons/next.svg?color1=%23333333&color2=
// module id = 915
// module chunks = 67